import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button, Typography } from "@mui/material";
import usendLogo from "../../assets/img/usendlogo.png";
import InputField from "../components/InputField";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateShopifyAppUser } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import PhoneInputWithCountryCode from "../components/PhoneInputWithCountryCode";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "550px",
  height: "auto",
  maxHeight: "auto",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  //   backgroundColor:"none",
  p: "18px",
  borderRadius: "37px",
};

export default function NewSetPasswordCreationModal({
  open,
  handleOpen,
  handleClose,
  userDetails,
}) {
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [phone, setPhone] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [values, setValues] = useState({
    password: "",
    confirmPassword: "",
  });

  const dispatch = useDispatch();

  const handleValues = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handlePasswordBlur = (event) => {
    const isValidPassword =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
        values.password
      );
    setPasswordError(!isValidPassword);
  };

  const handleConfirmPasswordBlur = (event) => {
    const isValidPassword = values.password === values.confirmPassword;
    if (values.confirmPassword !== "") {
      setConfirmPasswordError(!isValidPassword);
    }
  };

  React.useEffect(() => {
    // getting client api address
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIpAddress(data?.ip));
  }, []);

  const navigate = useNavigate();

  const localLoggedUser = JSON.parse(localStorage.getItem("loggedUser"));

  // Navigate to the appropriate dashboard based on user role
  React.useEffect(() => {
    const navigateBasedOnRole = () => {
      if (localLoggedUser?.user?.role) {
        const userRole = localLoggedUser?.user?.role;

        if (userRole === "admin") {
          navigate("/admin/dashboard");
        } else if (userRole === "customer") {
          navigate("/customer/dashboard");
        }
      }
    };

    navigateBasedOnRole();
  }, [navigate, localLoggedUser]);

  const boxShadow = "brgba(0, 0, 0, 0.09) 0px 3px 12px";
  const referralCode = JSON.parse(localStorage.getItem("referralCode"));
  return (
    <>
      <Typography
        variant="h5"
        component="h5"
        sx={{
          fontWeight: "700",
          color: "#212B36",
          fontSize: "24px",
          margin: 0,
        }}
        // className={`${styles.font_700} ${styles.deep_dark} ${styles.font_24}`}
        onClick={handleOpen}
      >
        Dashboard Overview
      </Typography>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        disableBackdropClick
        BackdropProps={{
          style: {
            pointerEvents: "none", // This ensures that the backdrop is not clickable
            backgroundColor: "rgba(0, 0, 0, 0.7) !important",
          },
        }}
        // disablePortal
      >
        <Fade in={open}>
          <Box sx={{ ...style }} className="">
            <div>
              <div
                style={{
                  padding: "10px 12px 5px 12px",
                  borderRadius: "5px",
                  marginRight: "20px",
                  marginTop: "5px",
                }}
              >
                <img
                  src={usendLogo}
                  style={{ boxShadow: boxShadow, borderRadius: "5px" }}
                  alt="productIcon"
                />
              </div>
              <h4>Choose a password</h4>
              <p style={{ fontWeight: 500, marginTop: "10px" }}>
                Welcome{" "}
                <span style={{ color: "#4F2498" }}>
                  {userDetails?.shop_details?.shop_owner}
                </span>
                , we are creating an account with your e-mail
                <span style={{ color: "#4F2498" }}>
                  {" "}
                  {userDetails?.shop_details?.owner_email}
                </span>
                .
              </p>
              <p style={{ fontWeight: 500 }}>
                To finalize your registration, let’s create a{" "}
                <span style={{ color: "#4F2498" }}> password</span>.
              </p>

              <div style={{ padding: "0px 20px" }}>
                <div style={{ marginBottom: "8px", marginTop:"20px" }}>
                  {" "}
                  <PhoneInputWithCountryCode setPhone={setPhone} />
                </div>
                <InputField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#F5F5F5",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "14px",
                    },
                  }}
                  placeholder="Create a password*"
                  type="password"
                  name="password"
                  passwordError={passwordError}
                  passwordHint="Password must be at least 8 characters long and contain a letter, a number and a symbol (@$!%*#?&)"
                  onBlur={handlePasswordBlur}
                  onChange={handleValues}
                  size="small"
                />
                <InputField
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#F5F5F5",
                    },
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "14px",
                    },
                  }}
                  placeholder="Confirm password*"
                  type="confirmPassword"
                  name="confirmPassword"
                  passwordError={confirmPasswordError}
                  onBlur={handleConfirmPasswordBlur}
                  onChange={handleValues}
                  size="small"
                />
                <h6 style={{ color: "#A3A3A3" }}>
                  Your password must be at least 8 characters, with a letter, a number and a symbol (@$!%*#?&).
                </h6>

                <Button
                  variant="lightblue"
                  sx={{
                    background: "#210C43",
                    margin: 0,
                    boxShadow: "none",
                    ":hover": {
                      background: "#210C43",
                    },
                  }}
                  className="w-full"
                  disabled={
                    // isEmpty.length !== 0 ||
                    passwordError || confirmPasswordError || !phone || !values.password || values.password !== values.confirmPassword
                  }
                  onClick={() =>
                    dispatch(
                      updateShopifyAppUser({
                        token: userDetails?.token,
                        password: values.password,
                        first_name:
                          userDetails?.shop_details?.shop_owner ||
                          userDetails?.shop_details?.shop_owner,
                        last_name: "",
                        phone,
                        ipAddress: ipAddress,
                        referralCode,
                      })
                    ).then(() => {
                      localStorage.removeItem("referralCode");
                      navigate("/customer/dashboard");
                    })
                  }
                >
                  Continue
                </Button>
                <small style={{ color: "#5B5B5B" }}>
                  By clicking Continue you agree on U-Send’s{" "}
                  <span
                    style={{
                      color: "#230C48",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        "/help/terms-and-conditions",
                        "_blank"
                      )
                    }
                  >
                    Terms and conditions
                  </span>{" "}
                  and{" "}
                  <span
                    style={{
                      color: "#230C48",
                      fontWeight: 500,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        "/help/privacy",
                        "_blank"
                      )
                    }
                  >
                    Privacy Policy
                  </span>
                </small>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
